import React from 'react';
const SvgNwc = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <defs>
        <path
          d="M.514 1.439C.6 5.016.657 8.206.23 8.144c1.4 1.73 1.884 2.97 1.48 3.733 1.262-.51.49-5.574-.73-11.625L.514 1.439z"
          id="nwc_svg__j"
        />
        <path d="M.216 15.34l3.092.068h.002C1.725 10.33.675 5.209.182.04l.034 15.3z" id="nwc_svg__a" />
        <path
          d="M.182.04C.675 5.21 1.725 10.332 3.31 15.408c-.404-3.296-.538-7.466-.505-9.483.034-2.018.975-2.657 2.489-.303 1.259 1.958 5.07 9.66 5.013 9.719l3.234.067-2.497-3.531L3.209.073.182.04z"
          id="nwc_svg__d"
        />
        <path id="nwc_svg__r" d="M.182.04h1.936v11.146H.182z" />
        <path d="M.314.252c1.22 6.05 1.993 11.115.73 11.625l2.497 3.531L3.508.275.314.252z" id="nwc_svg__g" />
        <path
          d="M.139 1.925c-.034 2.017.1 6.187.504 9.483l.704-.74.02-4.712c.011-2.51 1.078-1.032 1.422-.61.264.323 4.849 5.995 4.849 5.995.12.065-3.742-7.745-5.011-9.72C1.951.57 1.388.117.97.116.454.115.157.81.139 1.925"
          id="nwc_svg__o"
        />
        <path
          d="M.209.074l7.835 11.803c.404-.763-.08-2.002-1.48-3.733C5.695 7.956 2.892 3.894.21.074z"
          id="nwc_svg__m"
        />
        <path
          d="M0 .096h1.104L3.11 3.613V.096h.981v5.038H3.04L.98 1.555v3.579H0V.096zm5.224 0L5.89 2.98l.144.804.147-.786.567-2.902H7.86l.598 2.884.154.804.154-.773.673-2.915h1.07L9.09 5.134H8.085l-.609-2.947-.177-.974-.178.974-.608 2.947h-.978L4.106.096h1.118zm4.782 2.56c0-.88.236-1.558.708-2.034.41-.415.932-.622 1.565-.622.848 0 1.468.278 1.86.834.216.312.332.625.348.94h-1.052c-.069-.242-.157-.424-.264-.547-.191-.219-.475-.328-.85-.328-.384 0-.685.154-.907.463-.22.309-.331.746-.331 1.31 0 .566.117.99.35 1.27.234.282.53.423.89.423.37 0 .651-.121.845-.363.107-.13.196-.324.267-.584h1.042c-.091.55-.324.996-.699 1.34-.375.344-.855.516-1.44.516-.725 0-1.295-.232-1.71-.697-.414-.467-.622-1.108-.622-1.921z"
          id="nwc_svg__t"
        />
        <linearGradient x1="62.783%" y1="90.887%" x2="50%" y2="0%" id="nwc_svg__h">
          <stop stopColor="#20508D" offset="0%" />
          <stop stopColor="#4779B9" offset="59.285%" />
          <stop stopColor="#749BCB" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="-16.262%" x2="100%" y2="135.003%" id="nwc_svg__p">
          <stop stopColor="#0C2C54" offset="0%" />
          <stop stopColor="#4779B9" offset="70.757%" />
          <stop stopColor="#749BCB" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="-18.693%" x2="100%" y2="114.705%" id="nwc_svg__e">
          <stop stopColor="#749BCB" offset="0%" />
          <stop stopColor="#4779B9" offset="100%" />
        </linearGradient>
        <radialGradient
          cx="175.147%"
          cy="6.225%"
          fx="175.147%"
          fy="6.225%"
          r="249.48%"
          gradientTransform="matrix(.9266 .06878 -.86758 .391 .183 -.083)"
          id="nwc_svg__k"
        >
          <stop stopColor="#0B2B54" offset="0%" />
          <stop stopColor="#4679B8" offset="100%" />
        </radialGradient>
        <radialGradient
          cx="64.359%"
          cy="63.97%"
          fx="64.359%"
          fy="63.97%"
          r="118.659%"
          gradientTransform="matrix(-.96827 .05085 -.73055 -.57604 1.734 .975)"
          id="nwc_svg__b"
        >
          <stop stopColor="#1F508C" offset="0%" />
          <stop stopColor="#4679B8" offset="100%" />
        </radialGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#6B94C8" d="M3 31h26V8h-7V1H3z" />
        <path fill="#FFF" d="M4 2v20h24V8h-6V2z" />
        <path
          d="M9.277 19.5L9.243 4.32l2.934.033.457.65c2.611 3.723 5.077 7.238 5.918 7.42h.004l.02.001a.155.155 0 00.113-.051c.169-.173.254-.87.275-2.258.019-1.225-.017-2.868-.056-4.446l.448-1.138 3.091.023.033 15.01-3.146-.065-4.831-5.973a4.634 4.634 0 01-.062-.076c-.228-.285-.61-.762-.942-.762-.349 0-.521.486-.526 1.487l-.02 4.688-.669.703-3.007-.066z"
          fill="#4779B9"
        />
        <g transform="translate(9 4.219)">
          <mask id="nwc_svg__c" fill="#fff">
            <use xlinkHref="#nwc_svg__a" />
          </mask>
          <path
            d="M.216 15.34l3.092.068h.002C1.725 10.33.675 5.209.182.04l.034 15.3z"
            fill="url(#nwc_svg__b)"
            mask="url(#nwc_svg__c)"
          />
        </g>
        <g transform="translate(9 4.219)">
          <mask id="nwc_svg__f" fill="#fff">
            <use xlinkHref="#nwc_svg__d" />
          </mask>
          <path
            d="M.182.04C.675 5.21 1.725 10.332 3.31 15.408c-.404-3.296-.538-7.466-.505-9.483.034-2.018.975-2.657 2.489-.303 1.259 1.958 5.07 9.66 5.013 9.719l3.234.067-2.497-3.531L3.209.073.182.04z"
            fill="url(#nwc_svg__e)"
            mask="url(#nwc_svg__f)"
          />
        </g>
        <g transform="translate(19 4.219)">
          <mask id="nwc_svg__i" fill="#fff">
            <use xlinkHref="#nwc_svg__g" />
          </mask>
          <path
            d="M.314.252c1.22 6.05 1.993 11.115.73 11.625l2.497 3.531L3.508.275.314.252z"
            fill="url(#nwc_svg__h)"
            mask="url(#nwc_svg__i)"
          />
        </g>
        <g transform="translate(18.333 4.219)">
          <mask id="nwc_svg__l" fill="#fff">
            <use xlinkHref="#nwc_svg__j" />
          </mask>
          <path
            d="M.514 1.439C.6 5.016.657 8.206.23 8.144c1.4 1.73 1.884 2.97 1.48 3.733 1.262-.51.49-5.574-.73-11.625L.514 1.439z"
            fill="url(#nwc_svg__k)"
            mask="url(#nwc_svg__l)"
          />
        </g>
        <g transform="translate(12 4.219)">
          <mask id="nwc_svg__n" fill="#fff">
            <use xlinkHref="#nwc_svg__m" />
          </mask>
          <path
            d="M.209.074l7.835 11.803c.404-.763-.08-2.002-1.48-3.733C5.695 7.956 2.892 3.894.21.074z"
            mask="url(#nwc_svg__n)"
          />
        </g>
        <g transform="translate(11.667 8.219)">
          <mask id="nwc_svg__q" fill="#fff">
            <use xlinkHref="#nwc_svg__o" />
          </mask>
          <path
            d="M.139 1.925c-.034 2.017.1 6.187.504 9.483l.704-.74.02-4.712c.011-2.51 1.078-1.032 1.422-.61.264.323 4.849 5.995 4.849 5.995.12.065-3.742-7.745-5.011-9.72C1.951.57 1.388.117.97.116.454.115.157.81.139 1.925"
            fill="url(#nwc_svg__p)"
            mask="url(#nwc_svg__q)"
          />
        </g>
        <path
          d="M12.21 4.292l.289.425.288.427.577.851 1.147 1.708.287.428.285.428.57.855 1.141 1.713 1.135 1.716.567.859.565.86.564.86.282.43.141.216.146.212c.39.564.78 1.128 1.168 1.693-.4-.557-.797-1.116-1.196-1.674l-.149-.21-.144-.213-.287-.427-.573-.854-.574-.854-.57-.857-1.142-1.712-1.135-1.716-.567-.858-.284-.43-.282-.43-1.129-1.72-.561-.862-.28-.432-.28-.432z"
          fill="#A3BCDC"
        />
        <g transform="translate(9 4.219)">
          <mask id="nwc_svg__s" fill="#fff">
            <use xlinkHref="#nwc_svg__r" />
          </mask>
          <path
            d="M.182.04l.042.352.04.35.086.704.09.701.097.701c.133.934.278 1.866.441 2.795l.124.697.13.695.135.694.14.694.145.692.152.692.155.69.08.345.08.344-.092-.341-.089-.343-.173-.687-.163-.688-.156-.691-.149-.692-.14-.694-.133-.696-.126-.697-.117-.698-.11-.7-.102-.7C.536 3.325.506 3.09.475 2.856L.39 2.154.311 1.45.242.745.212.393.182.04z"
            fill="#A3BCDC"
            mask="url(#nwc_svg__s)"
          />
        </g>
        <path
          d="M20.044 16.096a.63.63 0 00.279-.238 1.3 1.3 0 00.163-.332c.04-.117.069-.238.091-.36a4.4 4.4 0 00.052-.367c.049-.494.04-.991.016-1.487-.027-.496-.07-.99-.126-1.484a43.362 43.362 0 00-.191-1.478 68.63 68.63 0 00-.228-1.474c-.08-.49-.166-.98-.25-1.47-.086-.49-.175-.98-.265-1.468l-.27-1.468.079.365.077.365.153.73c.098.488.194.976.287 1.464.186.978.354 1.959.497 2.944.07.493.135.987.187 1.482.051.495.094.991.112 1.49.01.248.013.498.009.747a7.767 7.767 0 01-.048.746 4.458 4.458 0 01-.061.37 2.458 2.458 0 01-.101.36 1.304 1.304 0 01-.173.332.642.642 0 01-.289.23M17.629 16.047l-.523-1.01c-.175-.338-.35-.674-.527-1.01-.352-.672-.706-1.343-1.068-2.009-.365-.665-.726-1.333-1.121-1.978a7.881 7.881 0 00-.654-.924 3.643 3.643 0 00-.391-.404 2.05 2.05 0 00-.222-.17 1.155 1.155 0 00-.244-.124.645.645 0 00-.263-.042.48.48 0 00-.245.085.792.792 0 00-.186.193 1.28 1.28 0 00-.127.245 2.571 2.571 0 00-.142.541c-.03.185-.047.374-.054.562-.02.756-.008 1.516.003 2.274a90.832 90.832 0 00.095 2.842l.029.569c.02.379.042.757.066 1.136l-.047-.567c-.014-.19-.028-.379-.04-.568a65.748 65.748 0 01-.072-1.136 87.826 87.826 0 01-.093-2.275 54.011 54.011 0 01-.021-1.993c0-.094.002-.19.006-.285.007-.19.023-.382.053-.57.03-.19.074-.378.145-.559a1.37 1.37 0 01.134-.26.83.83 0 01.206-.214.559.559 0 01.285-.1.761.761 0 01.296.046c.093.033.179.08.26.134.081.053.157.113.23.176.145.127.275.268.398.414.244.294.459.61.657.935.199.324.386.655.57.986.186.332.365.666.543 1.001a139.657 139.657 0 011.56 3.038l.253.51.25.51z"
          fill="#A3BCDC"
        />
        <path fill="#1B3F63" opacity={0.2} d="M29 15l-7-7h7z" />
        <path fill="#A1C4EE" d="M22 1l7 7h-7z" />
        <g>
          <g transform="translate(9 24)">
            <use fill="#000" xlinkHref="#nwc_svg__t" />
            <use fill="#FFF" xlinkHref="#nwc_svg__t" />
          </g>
        </g>
      </g>
    </svg>
  );
});
export default SvgNwc;
SvgNwc.iconName = 'nwc';
SvgNwc.displayName = 'SvgNwc';
